import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { BfeeGroupAPI, BfeeGroupInterface } from '../..';
import {mbeConfigService} from './mbe-config.service';
import { SortFilterInterface } from '@auth-suite-services/services';


@Injectable({
  providedIn: 'root',
})
export class BfeeGroupService {
  // Use pre-defined environment
  private URL;
  headers: HttpHeaders;

  constructor(
    @Inject(mbeConfigService) private config,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }
  private static handleHTTPError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }

  getAllBfee(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    sortFilter?: SortFilterInterface
  ): Observable<BfeeGroupAPI> {
    const headers = this.headers;
    if (sortActive === '' || sort === '') {
      sortActive = 'id';
      sort = 'asc';
    }
    // PK 09/02/2026 - Send empty object when payload is empty/0 so backend gets {} not number (avoids parsing error)
    // const body = sortFilter;
    const body =
      sortFilter && typeof sortFilter === 'object' && !Array.isArray(sortFilter)
        ? sortFilter
        : {};
    // tslint:disable-next-line:max-line-length
    return this.httpClient
      .post<BfeeGroupAPI>(
        `${this.URL}/bfg/allbfee/${pageIndex}/${pageSize}/${
          sortActive ? sortActive : 'id'
        }/${sort ? sort : 'asc'}`,
        body,
        { headers }
      )
      .pipe(catchError(BfeeGroupService.handleHTTPError));
    // /${pageIndex}/${pageSize}/${sortActive}/${sort}
  }
  getRiskClass(): Observable<BfeeGroupAPI> {
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    // PK 09/02/2026 - Fixed malformed URL: removed stray '}' so path is /bfg/riskclass not /bfg/riskclass}
    // return this.httpClient.get<BfeeGroupAPI>(`${this.URL}/bfg/riskclass}`, {
    return this.httpClient.get<BfeeGroupAPI>(`${this.URL}/bfg/riskclass`, {
      headers,
    });
    // /${pageIndex}/${pageSize}/${sortActive}/${sort}
  }

  getBfee(id: number): Observable<BfeeGroupInterface> {
    const headers = this.headers;
    return this.httpClient.get<BfeeGroupInterface>(
      `${this.URL}/bfg/singlebfee/${id}`,
      { headers }
    );
    // /${pageIndex}/${pageSize}/${sortActive}/${sort}
  }

  // CreateSource(source: BfeeGroupInterface): Observable<BfeeGroupInterface> {
  //   const headers = this.headers;
  //   return this.httpClient.post<BfeeGroupInterface>(`${this.URL}/bfeeGroup/createsource`, source, { headers });
  //   // /${pageIndex}/${pageSize}/${sortActive}/${sort}
  // }

  CreateBfee(source: BfeeGroupInterface): Observable<BfeeGroupInterface> {
    const headers = this.headers;
    return this.httpClient.post<BfeeGroupInterface>(
      `${this.URL}/bfg/createbfeegroup`,
      source,
      { headers }
    );
    // /${pageIndex}/${pageSize}/${sortActive}/${sort}
  }

  UpdateBfee(source: BfeeGroupInterface): Observable<BfeeGroupInterface> {
    const headers = this.headers;
    return this.httpClient.post<BfeeGroupInterface>(
      `${this.URL}/bfg/updatebfee`,
      source,
      { headers }
    );
    // /${pageIndex}/${pageSize}/${sortActive}/${sort}
  }

  cloneBfeeGroup(id: number, newName: string): Observable<BfeeGroupInterface> {
    const headers = this.headers;
    return this.httpClient.post<BfeeGroupInterface>(
      `${this.URL}/bgc/clonebfee/${id}`,
      { newName },
      { headers }
    );
  }
}

